(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1681],{

/***/ 5929:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-engine/blog/page/[page]",
      function () {
        return __webpack_require__(86303);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_marketingSite_talentEngineV3_blog_BlogComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69641);
/* harmony import */ var components_shared_HeadMetadata__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73412);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39105);
/* harmony import */ var hooks_usePageTrack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56002);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62177);
/* harmony import */ var utils_paths__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64516);








var BlogPage = function(props) {
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_3__/* .useI18n */ .Q)("blog").t;
    (0,hooks_usePageTrack__WEBPACK_IMPORTED_MODULE_4__/* .usePageTrack */ .N)("Blog - Page Loaded");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_HeadMetadata__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: t("talent-engine-blog.pageTitle"),
                desc: t("talent-engine-blog.page_description"),
                imgUrl: (0,utils_paths__WEBPACK_IMPORTED_MODULE_6__/* .getPublicPath */ .A)("/images/card_blog.png"),
                url: utils_app_urls__WEBPACK_IMPORTED_MODULE_5__/* .APP_URLS.talentEngineBlog */ .uu.talentEngineBlog,
                path: {
                    ES: "page/".concat(props.currentPage),
                    EN: "page/".concat(props.currentPage)
                },
                indexable: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_marketingSite_talentEngineV3_blog_BlogComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,9161,9092,8707,6450,9774,2888,179], function() { return __webpack_exec__(5929); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);